<template>
  <div class="loadingContainer">
    <transition name="fade">
      <div class="loadingOverlay" v-if="loading">
        <div class="spinner">
          <SpinnerIcon/>
        </div>
      </div>
    </transition>
    <slot/>
  </div>
</template>


<script>
import SpinnerIcon from '@/assets/img/spinner.svg';
export default {
  name: "Loading",
  props: ["loading"],
  components:{
    SpinnerIcon
  }
};
</script>

<style lang="scss" scoped>
.loadingOverlay {
  background: rgba($color: white, $alpha: 1);
  height: 100%;
  position: absolute;
  z-index: 150;
  // Allow for page padding, ensure loading takes full width of page
//   width: calc(100% + 30px);
//   margin-left: -15px;
	width: 100%;
}

.loadingContainer {
  position: relative;
}

.spinner {
  width: 150px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  svg {
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
